<template xmlns:v-tooltip="http://www.w3.org/1999/xhtml">
  <div id="wrapper">

    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">

          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li class="active">
                <span>Projects</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Projects
          </h3>
          <small>List of Projects</small>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="row">

        <div class="col-lg-12">
          <div class="hpanel">
            <div class="panel-body">
              <div class="col-lg-8 col-md-6 ">
                <search-project-box v-model="search"/>
              </div>
              <div class="col-lg-2 col-md-3 col-xs-6 m-t-md">
                <button type="button" class="btn btn-info btn-outline  btn-block"
                        @click="modalPortfolioAction = 'create'">
                  <i class="fa fa-plus"></i> New Portfolio
                </button>
              </div>
              <div class="col-lg-2 col-md-3 col-xs-6 m-t-md">
                <button type="button" class="btn btn-info btn-block" id="projects-new_project"
                        @click="modalProjectAction = 'create'">
                  <i class="fa fa-plus"></i> New Project
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row" v-if="!$auth.check('seeker') && !$auth.check('basic')">

        <div class="text-center m-b-md" id="wizardControl">
          <a class="btn" :class="tabProjectSelected === 'myProjects' ? 'btn-primary' : 'btn-default'"
             @click="tabProjectSelected = 'myProjects'"
             data-content="Access the projects you own"
             href="#tab-myProjects" data-toggle="tab" style="min-width: 150px">Own Projects</a>

          <a class="btn" :class="tabProjectSelected === 'consultantProject' ? 'btn-primary' : 'btn-default'"
             @click="tabProjectSelected = 'consultantProject'"
             data-content="Access the projects of your attached seeker accounts"
             href="#tab-consultantProjects" data-toggle="tab" style="min-width: 150px">Projects as Broker</a>

          <a class="btn" :class="tabProjectSelected === 'noConsultantProject' ? 'btn-primary' : 'btn-default'"
             @click="tabProjectSelected = 'noConsultantProject'"
             data-content="Access the seeker projects without assigned broker"
             href="#tab-noConsultantProjects" data-toggle="tab" style="min-width: 150px"
             v-if="$auth.check('manager') || $auth.check('super_admin')" >Unassigned Projects</a>

          <a class="btn" :class="tabProjectSelected === 'allProjects' ? 'btn-primary' : 'btn-default'"
             @click="tabProjectSelected = 'allProjects'"
             :data-content="'Access all the ' + $auth.user().profile.name + ' projects'"
             href="#tab-allProjects" data-toggle="tab" style="min-width: 150px"
             v-if="$auth.check('manager') || $auth.check('super_admin')">All Projects</a>
        </div>
        <div class="tab-content">
          <div id="tab-myProjects" class="p-m tab-pane active">
            <my-projects :projects="projects" :portfolios="portfolios" v-model="refresh"></my-projects>
          </div>
          <div id="tab-consultantProjects" class="p-m tab-pane">
            <consultant-projects :projects="projects" v-model="refresh"></consultant-projects>
          </div>
          <div id="tab-noConsultantProjects" class="p-m tab-pane">
            <no-consultant-projects v-if="$auth.check('manager') || $auth.check('super_admin')"
                                    :projects="projects" v-model="refresh"></no-consultant-projects>
          </div>
          <div id="tab-allProjects" class="p-m tab-pane">
            <all-projects v-if="$auth.check('manager') || $auth.check('super_admin')"
                          :projects="projects" v-model="refresh"></all-projects>
          </div>
        </div>
      </div>
      <div v-else>
        <my-projects :projects="projects" :portfolios="portfolios" v-model="refresh"></my-projects>
      </div>
    </div>
    <template v-if="modalProjectAction">
      <action-modal-project :project="null" v-model="modalProjectAction"/>
    </template>
    <template v-if="modalPortfolioAction">
      <action-modal-portfolio :portfolio="null" v-model="modalPortfolioAction"/>
    </template>
  </div>
</template>

<style>
  #dLabel1, #dLabel2{color: #fff;
    background-color: #204d74;
    border-color: #122b40}
  .m-t-md {
    margin-top: 22px;
  }
</style>

<script>
import ActionModalPortfolio from '../../components/project/ActionModalPortfolio'
import ActionModalProject from '../../components/project/ActionModalProject'
import ActionModalAssignedToConsultant from '../../components/project/ActionModalAssignedToConsultant'
import PortfolioListRow from '../../components/project/PortfolioListRow'
import ProjectItem from '../../components/project/ProjectItem'
import SearchProjectBox from '../../components/project/SearchProjectBox'
import MyProjects from '../../components/project/MyProjects'
import ConsultantProjects from '../../components/project/ConsultantProjects'
import NoConsultantProjects from '../../components/project/NoConsultantProjects'
import AllProjects from '../../components/project/AllProjects'

export default {
  components: {
    AllProjects,
    MyProjects,
    ConsultantProjects,
    NoConsultantProjects,
    SearchProjectBox,
    ProjectItem,
    PortfolioListRow,
    ActionModalPortfolio,
    ActionModalProject,
    ActionModalAssignedToConsultant
  },
  props: [],
  name: 'Projects',
  methods: {
    getResources: function () {
      this.getProjects()
    },
    getProjects: function () {
      this.axios.get('/projects/?relations={workflow,myPortfolio,lists,owner,question,question.consultant,' +
        'question.mailing,question.status,sharedWith}')
        .then((response) => {
          this.parse(response.data.portfolios, response.data.projects)
        })
        .catch((error) => {
        })
    },
    parse: function (portfoliosData, projectsData) {
      let portfolios = {}
      let projects = []

      portfoliosData.forEach((portfolio) => {
        if (typeof portfolios[portfolio.id] === 'undefined') {
          portfolios[portfolio.id] = portfolio
          portfolios[portfolio.id].projects = []
        }
      })

      projectsData.forEach((project) => {
        if (project.my_portfolio !== null && project.my_portfolio.length !== 0) {
          let portfolioId = project.my_portfolio[0].id
          if (typeof portfolios[portfolioId] !== 'undefined') {
            portfolios[portfolioId].projects.push(project)
          } else {
            projects.push(project)
          }
        } else {
          projects.push(project)
        }
      })

      let portfolioList = []
      for (let portfolioId in portfolios) {
        portfolioList.push(portfolios[portfolioId])
      }

      this.portfolios = portfolioList
      this.projects = projects
    }
  },
  watch: {
    modalProjectAction: function (val) {
      if (val === null) {
        this.refresh = Date.now()
      }
    },
    modalPortfolioAction: function (val) {
      if (val === null) {
        this.refresh = Date.now()
      }
    },
    refresh: function (val) {
      this.getProjects()
    },
    search: function (value) {
      if (value !== null && value !== '') {
        this.projects = this.projects.filter((project) => {
          return (project.name.search(new RegExp(value, 'i')) !== -1) ||
              ((project.description !== null ? project.description.search(new RegExp(value, 'i')) : -1) !== -1)
        })

        this.portfolios = this.portfolios.filter((portfolio) => {
          let portfolioMatch = (portfolio.name.search(new RegExp(value, 'i')) !== -1) ||
            ((portfolio.description !== null ? portfolio.description.search(new RegExp(value, 'i')) : -1) !== -1)

          portfolio.projects = portfolio.projects.filter((project) => {
            return (project.name.search(new RegExp(value, 'i')) !== -1) ||
              ((project.description !== null ? project.description.search(new RegExp(value, 'i')) : -1) !== -1)
          })

          let projectMatch = false

          if (portfolio.projects.length !== 0) {
            projectMatch = true
          }

          return (projectMatch || portfolioMatch)
        })
      } else {
        this.getProjects()
      }
    }
  },
  data () {
    return {
      localAllProjects: [],
      tabProjectSelected: 'myProjects',
      portfolios: [],
      projects: [],
      refresh: null,
      portfolioAction: null,
      initShowHidePanel: false,
      search: null,
      modalProjectAction: null,
      modalPortfolioAction: null,
      mounted: false,
      showQuota: false
    }
  },
  mounted () {
    this.mounted = true

    $('#wizardControl>a').popover({
      trigger: 'hover',
      placement: 'top'
    })

  },
  updated () {
    if (this.projects !== null && this.projects.length > 0) {
      this.$eventHub.$emit('tour-projects-first_project', null)
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/project/Projects.vue